/**
 * OG Trivia Crack wheel order (clockwise): six subjects + crown slice for choose-any-category.
 */
export const TRIVIA_CATEGORY_KEYS = [
  "entertainment",
  "art",
  "sports",
  "science",
  "history",
  "geography",
] as const;

export type TriviaCategoryKey = (typeof TRIVIA_CATEGORY_KEYS)[number];

export const CATEGORY_COUNT = TRIVIA_CATEGORY_KEYS.length;
export const WHEEL_SEGMENT_COUNT = CATEGORY_COUNT + 1;
export const CROWN_SEGMENT_INDEX = CATEGORY_COUNT;

/** @deprecated use CATEGORY_COUNT */
export const WEDGE_COUNT = CATEGORY_COUNT;

/** Same stable id as `MEM_CPU_ID` in dev accounts. */
export const MEM_CPU_USER_ID = "cccccccc-cccc-4ccc-8ccc-cccccccccccc";

export function isTriviaCategoryKey(s: string): s is TriviaCategoryKey {
  return (TRIVIA_CATEGORY_KEYS as readonly string[]).includes(s);
}

export function isCrownWheelSegment(segment: number): boolean {
  return segment === CROWN_SEGMENT_INDEX;
}
